import React from 'react';
import { AlertTriangle, Loader2, Share2, X, Check } from 'lucide-react';
import { AmountsEditor } from './AmountsEditor';
import { shareSelection } from '../../lib/selectionShare';

const inputCls = 'w-full bg-[#111] border border-white/10 rounded-xl px-3 py-2.5 text-white font-bold text-sm outline-none focus:border-[#F5A623]/60';

const Field = ({ label, children }) => (
  <label className="block mb-3">
    <span className="block text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-1">{label}</span>
    {children}
  </label>
);

// Name, code, errors allowed (Sistema), amounts + responsible-gaming notice; "save" confirms, "edit" only keeps the values
export const SaveDetails = ({ value, onChange, kind, events, mode, saving, saved, onConfirm, onClose }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="fixed inset-0 z-[9990] bg-[#121212] overflow-y-auto" data-testid="save-details">
      <div className="max-w-md mx-auto px-4 pt-5 pb-[calc(2rem+env(safe-area-inset-bottom,0px))]">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-white font-black text-lg">{mode === 'save' ? 'Salva selezione' : 'Dettagli selezione'}</h3>
          <button type="button" onClick={onClose} className="p-1 text-gray-400" data-testid="save-details-close"><X className="w-6 h-6" /></button>
        </div>
        <Field label="Nome">
          <input value={value.name} onChange={(e) => set('name', e.target.value)} maxLength={60} className={inputCls} data-testid="save-details-name" />
        </Field>
        <Field label="Codice precompilata">
          <input value={value.code} onChange={(e) => set('code', e.target.value)} maxLength={40} className={inputCls} data-testid="save-details-code" />
        </Field>
        {kind === 'sistema' && (
          <Field label="Errori consentiti">
            <input type="number" inputMode="numeric" min={0} max={Math.max(events - 1, 0)} value={value.errors}
              onChange={(e) => set('errors', e.target.value === '' ? '' : Math.max(0, Math.min(parseInt(e.target.value, 10) || 0, Math.max(events - 1, 0))))}
              className={inputCls} data-testid="save-details-errors" />
          </Field>
        )}
        <AmountsEditor value={value.amounts} onChange={(a) => set('amounts', a)} testid="save-details-amounts" />
        {kind === 'sistema' && <p className="mt-2 text-[11px] text-gray-500">Nel sistema la vincita è quella che scrivi tu: non abbiamo le quote dei singoli eventi.</p>}
        {mode === 'save' && (
          <p className="mt-5 rounded-xl bg-[#F5A623]/10 border border-[#F5A623]/40 text-[#F5A623] text-xs p-3 flex gap-2" data-testid="save-details-disclaimer">
            <AlertTriangle className="w-4 h-4 shrink-0" />
            <span>Gli importi proposti sono quelli tracciati dall'autore della selezione. Modificali secondo la tua disponibilità prima di confermare. Confermando il salvataggio confermi di essere consapevole della tua azione autonoma. Gioca responsabilmente.</span>
          </p>
        )}
        {saved ? (
          <div className="mt-4 space-y-2">
            {!saved.vip_copy && (
            <button type="button" onClick={() => shareSelection(saved)} className="w-full py-3 rounded-xl bg-gradient-to-r from-[#F5A623] to-[#FF6B6B] text-[#1A1A1A] font-black flex items-center justify-center gap-2" data-testid="save-details-share">
              <Share2 className="w-4 h-4" /> Condividi link
            </button>
            )}
            <button type="button" onClick={onClose} className="w-full py-3 rounded-xl border border-white/15 text-white font-black" data-testid="save-details-done">Fatto</button>
          </div>
        ) : (
          <button type="button" onClick={mode === 'save' ? onConfirm : onClose} disabled={saving}
            className="mt-4 w-full py-3 rounded-xl bg-[#F5A623] text-[#1A1A1A] font-black flex items-center justify-center gap-2 disabled:opacity-50" data-testid="save-details-confirm">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />} {mode === 'save' ? 'Conferma' : 'Fatto'}
          </button>
        )}
      </div>
    </div>
  );
};

export default SaveDetails;
